import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import KBTOCList from '@/models/KnowledgeBase/KBTOCList';

export interface ISysKBTOCListState {
  loading: boolean;
  tocList: KBTOCList | null;
}

@Module({ dynamic: true, store, name: 'SysKBTOCList', namespaced: true })
class SysKBTOCList extends VuexModule implements ISysKBTOCListState {

  public loading = false;
  public tocList: KBTOCList | null = null;

  @Action
  async getTOCList() {
    this.setLoading(true);
    return ajax.get('/api/v1/sys/kb/tocs')
      .then(response => {
        this.context.commit('setTOCList', response.data);
        this.setLoading(false);
        return response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoading(false);
        throw error;
      });
  }

  @Action
  cleanState() {
    this.context.commit('resetState');
  }

  @Mutation
  resetState() {
    this.tocList = null;
    this.loading = false;
  }

  @Mutation
  private setLoading(loading: boolean) {
    this.loading = loading;
  }

  @Mutation
  private setTOCList(list: KBTOCList) {
    this.tocList = list;
  }
}

export const SysKBTOCListModule = getModule(SysKBTOCList);
